import moment from 'moment';
import 'moment/locale/id';
import { isNone, isInteger, isBoolean, isString, isArray, isObject } from "iotera-base/object";
import { isFloat } from "../../function";
import { DATE_YEAR, DATE_MONTH, DATE_DAY, DATE_MINUTE, DATE_MINUTE_SIMPLE, DATE_DAY_SIMPLE, DATE_MONTH_SIMPLE, DATE_MINUTE_SECOND_SIMPLE, DATE_MINUTE_SECOND } from '../Preference';


/**
 * Number.formatter(input n, x, s, c)
 * 
 * @param integer input: input integer to format
 * @param integer n: length of decimal
 * @param integer x: length of whole part
 * @param mixed   s: sections delimiter
 * @param mixed   c: decimal delimiter
 */

export function numberFormatter(input, n, x, s, c) {

    if ((!isInteger(input) && !isFloat(input)) || (input === Infinity || input === -Infinity)) {
        return input;
    }
    let re, num;

    num = input.toFixed(Math.max(null, ~~n));


    let numTemp = num;
    if (num.includes('.')) {
        let indexDot = num.lastIndexOf('.');
        if (indexDot === -1) {
            indexDot = num.length
        }
        let length = num.length
        for (let z = length - 1; z >= indexDot; z--) {
            if (num.charAt(z) === '0') {
                numTemp = numTemp.slice(0, z);
            } else if (num.charAt(z) === '.') {
                numTemp = numTemp.slice(0, z);
                z = 0;
            } else {
                z = 0;
            }
        }
        num = numTemp
    }

    if (num.includes('.')) {
        re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')';
    } else {
        re = '\\d(?=(\\d{' + (x || 3) + '})+$)';
    }

    let output = (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || '.'));

    return output;
};

export function upperFirstLetter(sts) {
    let uppercaseFirstLetter = sts.charAt(0).toUpperCase();
    let stringWithoutFirstLetter = sts.slice(1)
    return uppercaseFirstLetter + stringWithoutFirstLetter;
}

export function lowercaseSpaceReplace(str, replace_char) {
    if (isNone(replace_char) || replace_char === '')
        replace_char = '_'
    return str.toLowerCase().replace(/ /g, replace_char)
}

export function titleCaseRemoveUS(str) {
    str = str.replace(/_/g, ' ')
    str = titleCase(str)
    return str;
}

export function titleCase(str) {
    if (isNone(str) || str === '')
        return str;
    let splitStr = str.toLowerCase().split(' ');
    for (let i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(' ');
}

export function subTitleCase(str) {
    if (isNone(str) || str === '')
        return str;
    let strLower = str.toLowerCase();
    return strLower.charAt(0).toUpperCase() + strLower.slice(1);
}

export function toSimpleNumber(value, decimalToShow) {
    let decimal = decimalToShow === null || decimalToShow === undefined ? 3 : decimalToShow;

    if (!isInteger(value) && !isFloat(value)) {
        return value;
    }

    if (value > 1000000000000) {

        value /= 1000000000000;
        if (isInteger(value)) {
            decimal = 0;
        }
        value = numberFormatter(value, decimal, 3, '', ',');
        return value + 'T'
    } else if (value > 1000000000) {

        value /= 1000000000;
        if (isInteger(value)) {
            decimal = 0;
        }
        value = numberFormatter(value, decimal, 3, '', ',');
        return value + 'B'
    } else if (value > 1000000) {

        value /= 1000000;
        if (isInteger(value)) {
            decimal = 0;
        }
        value = numberFormatter(value, decimal, 3, '', ',');
        return value + 'M'
    } else if (value > 1000) {
        value /= 1000;
        if (isInteger(value)) {
            decimal = 0;
        }
        if (decimal < 3 && value >= 1) {
            value = numberFormatter(value, decimal, 3, '', ',');
            return value + 'k'
        } else {
            value *= 1000;
            value = numberFormatter(value, 0, 3, '', ',')
            return value;
        }
    } else {
        if (isInteger(value)) {
            decimal = 0;
        }
        return numberFormatter(value, decimal, 3, '', ',')
    }
}

export function toDate(timestamp, format, isSimple, isSecondShown) {
    if (isNone(format)) {
        format = 'HH:mm:ss, DD MMM \'YY'
    }
    if (isSimple === null) {
        isSimple = false
    }
    if (isSecondShown === null) {
        isSecondShown = false
    }
    if (!isInteger(timestamp) && !isFloat(timestamp)) {
        format = getDateType(timestamp, isSimple, isSecondShown)
        let something = moment(timestamp).format(format)
        return something;
    }
    timestamp /= 1000;
    return moment.unix(timestamp).format(format);
}

export function toDashboardDate(timestamp) {
    let format = 'HH:mm'

    if (!isInteger(timestamp) && !isFloat(timestamp)) {
        let something = moment(timestamp).format(format)
        return something;
    }

    timestamp /= 1000;
    return moment.unix(timestamp).format(format);
}

export function getDateType(date, isSimple, isSecondShown) {
    if (isSimple === null) {
        isSimple = false
    }

    if (isSecondShown === null) {
        isSecondShown = false
    }

    if (isSimple) {
        if (date.length < 5) {
            return DATE_YEAR
        } else if (date.length < 8) {
            return DATE_MONTH_SIMPLE
        } else if (date.length < 11) {
            return DATE_DAY_SIMPLE
        } else {
            if (isSecondShown) {
                return DATE_MINUTE_SECOND_SIMPLE
            } else {
                return DATE_MINUTE_SIMPLE
            }
        }
    } else {
        if (date.length < 5) {
            return DATE_YEAR
        } else if (date.length < 8) {
            return DATE_MONTH
        } else if (date.length < 11) {
            return DATE_DAY
        } else {
            if (isSecondShown) {
                return DATE_MINUTE_SECOND
            } else {
                return DATE_MINUTE
            }
        }
    }

}

export function inputToString(input) {
    if (isBoolean(input)) {
        if (input === true) {
            input = 'true';
        } else {
            input = 'false';
        }
    }
    return input;
}

export function checkIsVar(str) {
    let first = str.substring(0, 1);
    let last = str.substring(str.length - 1, str.length);

    if (first === '{' && last === '}') {
        return true
    } else {
        return false
    }
}

export function stringToVar(str) {
    if (!isString(str)) {
        return str
    } else {
        if (!checkIsVar(str)) {
            return '{' + str + '}'
        } else {
            return str
        }
    }
}

export function removeBracet(string) {
    if (!isString(string)) {
        return string
    }
    if (string.length < 2) {
        return string
    } else {
        if (stringToVar(string)) {
            return string.substring(1, string.length - 1)
        } else {
            return string
        }
    }
}

export function arrToVarArr(arr) {
    if (!isArray(arr)) {
        return arr
    } else {
        let newArr = []
        for (let i = 0; i < arr.length; i++) {
            let currStr = arr[i];
            currStr = stringToVar(currStr);
            newArr.push(currStr)
        }
        return newArr
    }
}

export function sortObject(obj) {
    for (let keys in obj) {
        let currValue = obj[keys];
        if (isObject(currValue)) {
            obj[keys] = sortObject(currValue)
        }
    }
    return Object.keys(obj).sort().reduce((r, k) => (r[k] = obj[k], r), {});
}